import React from 'react';
import '../../styles/BackgroundTheme.css';

interface ThemeBackgroundProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'full' | 'minimal';
}

const ThemeBackground: React.FC<ThemeBackgroundProps> = ({ 
  children, 
  className = '', 
  variant = 'full' 
}) => {
  return (
    <div className={`app-background ${className}`}>
      {variant === 'full' && (
        <>
          <div className="background-blur-1"></div>
          <div className="background-blur-2"></div>
          <div className="background-blur-3"></div>
          <div className="background-blur-4"></div>
        </>
      )}
      <div className="app-content">
        {children}
      </div>
    </div>
  );
};

export default ThemeBackground;
